import React from "react";

// --- CSS --- //
import "../../styles/gyms.css";

// --- ASSETS --- //
import mockup_1 from "../../assets/mockup-gym-1.png";
import mockup_2 from "../../assets/mockup-gym-2.png";
import mockup_3 from "../../assets/mockup-gym-3.png";
import mockup__mac_1 from "../../assets/mockup-mac-1.png";

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Gyms = () => {
    return (
        <>
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                    <h1>Streamline Your Certification Process</h1>
                    <p>Manage and certify climbers with ease. Our intuitive platform helps you track authorized certifying employees, certify climbers quickly, and grow your client base faster than ever.</p>
                    <a href="/contact">
                        <button className="cta-button">Become a Partner Today</button>
                    </a>
                </div>
                <div className="hero-image">
                    <img src={mockup__mac_1} alt="App Mockup" />
                </div>
                <div className="hero-scroll-down">
                    <KeyboardArrowDownIcon style={{ fontSize: "30pt" }} />
                </div>
            </section>

            {/* Features Section */}
            <section className="features">
                <h2>What You Get</h2>
                <div className="features-grid">
                    <div className="feature-item">
                        <img src={mockup_1} alt="Feature 1" />
                        <h3>Effortless Employee Management</h3>
                        <p>Track and manage your authorized certifying employees in one easy-to-use platform, ensuring smooth operations at your gym.</p>
                    </div>
                    <div className="feature-item" id="feature-middle-item">
                        <img src={mockup_2} alt="Feature 2" />
                        <h3>Simple, Intuitive Certification Console</h3>
                        <p>Certify climbers quickly and easily through our intuitive console—getting climbers certified with just a few clicks.</p>
                    </div>
                    <div className="feature-item">
                        <img src={mockup_3} alt="Feature 3" />
                        <h3>Expand Your Client Base</h3>
                        <p>Reach more climbers by joining our nationwide network of gyms. VertCert helps you attract new clients while retaining existing ones.</p>
                    </div>
                </div>
            </section>

            {/* How It Works Section */}
            <section className="how-it-works">
            <object className="background-graphic" aria-label="Background graphic representing VERT CERT experience"></object>
                <h2>The VERT CERT Experience: Empowering Your Gym</h2>
                <div className="how-it-works-content">
                    <div className="how-it-works-steps">
                        <div className="step">
                            <h3 className="step-number">1.</h3>
                            <div className="step-content" id="step-content-first-content" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                <div style={{ marginRight: "20px" }}>
                                    <h3>Create Your Gym Profile</h3>
                                    <p>Contact us to create your gym's VERT CERT profile to start certifying climbers in no time.</p>
                                </div>
                                <a href="/contact"><button className="cta-button" id="step-content-first-content-button">Become a Partner</button></a>
                            </div>
                        </div>
                        <div className="step">
                            <h3 className="step-number">2.</h3>
                            <div className="step-content">
                                <h3>Assign Authorized Employees</h3>
                                <p>Designate certified employees who can certify climbers at your gym, giving you full control over your certification process.</p>
                            </div>
                        </div>
                        <div className="step">
                            <h3 className="step-number">3.</h3>
                            <div className="step-content">
                                <h3>Certify Climbers</h3>
                                <p>Using our platform's intuitive console, certify climbers quickly and efficiently—no hassle, just results.</p>
                            </div>
                        </div>
                        <div className="step">
                            <h3 className="step-number">4.</h3>
                            <div className="step-content">
                                <h3>Grow Your Client Base</h3>
                                <p>Expand your reach through our nationwide network of gyms. Climbers with VERT CERT certifications are ready to explore your gym with ease.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call-to-Action Section */}
            <section className="cta">
                <h2>Empower Your Gym with VERT CERT</h2>
                <p>Join the platform that makes climbing certifications faster, easier, and more accessible. Start certifying climbers and grow your business today.</p>
                <a href="/contact">
                    <button className="cta-button" id="cta-sign-up-button">Become a Partner</button>
                </a>
            </section>
        </>
    );
};

export default Gyms;